import axios from 'axios'
import { isFunction as _isFunction } from 'lodash'
import { retrieveUtilities } from '@vfgroup-oneplatform/foundation/Utils/ServicesUtils/Utilities'

import { API_URLS } from './Config'

const GetTransferBalanceOptions = async (
    msisdn,
    customHeaders = {},
    utilities = {},
) => {
    const _utilities = retrieveUtilities(utilities)

    const { onStart, onSuccess, onError, responseMapper, errorMapper } = _utilities

    onStart()

    try {
        const response = await axios.get(API_URLS.getBalanceOptions + msisdn, {
            headers: customHeaders,
        })

        const _response = responseMapper(response)
        onSuccess(_response)
        return _response
    } catch (error) {
        const _error = errorMapper(error)
        if (_isFunction(onError)) {
            onError(_error)
        } else {
            throw _error
        }
    }
}

const GetTransferDataOptions = async (
    customHeaders = {},
    utilities = {},
) => {
    const _utilities = retrieveUtilities(utilities)

    const { onStart, onSuccess, onError, responseMapper, errorMapper } = _utilities

    onStart()

    try {
        const response = await axios.get(API_URLS.getDataOptions, {
            params: {
                type: 'transfer',
                status: 'requested',
            },
            headers: customHeaders,
        })
        const _response = responseMapper(response)
        onSuccess(_response)
        return _response
    } catch (error) {
        const _error = errorMapper(error)
        if (_isFunction(onError)) {
            onError(_error)
        } else {
            throw _error
        }
    }
}

const GetTransferVcoinsOptions = async (
    msisdn,
    customHeaders = {},
    utilities = {},
) => {
    const _utilities = retrieveUtilities(utilities)

    const { onStart, onSuccess, onError, responseMapper, errorMapper } = _utilities

    onStart()
    try {
        const response = await axios.get(API_URLS.getVcoinsOptions, {
            headers: customHeaders,
            params: {
                relatedPartyId: msisdn,
                senderId: msisdn,
                counter: 0,
                limit: 10,
            },
        })
        const _response = responseMapper(response)
        onSuccess(_response)
        return _response
    } catch (error) {
        const _error = errorMapper(error)
        if (_isFunction(onError)) {
            onError(_error)
        } else {
            throw _error
        }
    }
}

const TransferBalance = async (
    transferDetails,
    msisdn,
    customHeaders = {},
    utilities = {},
) => {
    const _utilities = retrieveUtilities(utilities)

    const { onStart, onSuccess, onError, responseMapper, errorMapper } = _utilities

    const data = {
        'details': {
            'adjustment-amount': {
                '@currency-id': transferDetails.currency,
                '$': transferDetails.value,
            },
        },
        'roles': {
            'receiver': {
                'ids': [
                    {
                        '$': transferDetails.receiver,
                    },
                ],
            },
            'sender': {
                'ids': [
                    {
                        '$': msisdn,
                    },
                ],
            },
        },
        'type': {
            '$': 'transfer',
        },
    }

    onStart()

    try {
        const response = await axios.post(API_URLS.tranferBalance, data, {
            headers: customHeaders,
        })

        const _response = responseMapper(response)
        onSuccess(_response)
        return _response
    } catch (error) {
        const _error = errorMapper(error)
        if (_isFunction(onError)) {
            onError(_error)
        } else {
            throw _error
        }
    }
}

const TransferData = async (
    transferDetails,
    msisdn,
    customHeaders = {},
    utilities = {},
) => {
    const _utilities = retrieveUtilities(utilities)

    const { onStart, onSuccess, onError, responseMapper, errorMapper } = _utilities

    const data = {
        categories: [
            {
                $: '',
            },
        ],
        details: {
            'adjustment-quantity': transferDetails.details,
        },
        parts: {
            'triggered-by': {
                ids:
                    [
                        {
                            '@scheme-agency-name': 'Vodafone',
                            '@scheme-name': 'Vodafone',
                            '$': 'selfcare',
                        },
                    ],
            },
        },
        roles: {
            receiver: {
                ids:
                    [
                        {
                            '@scheme-agency-name': 'Vodafone',
                            '@scheme-name': 'Vodafone',
                            '$': transferDetails?.receiver,
                        },
                    ],
            },
            sender: {
                ids:
                    [
                        {
                            '@scheme-agency-name': 'Vodafone',
                            '@scheme-name': 'Vodafone',
                            '$': msisdn,
                        },
                    ],
            },
        },
        type: {
            '$': 'transfer',
        },
    }

    onStart()

    try {
        const response = await axios.post(API_URLS.transferData, data, {
            headers: customHeaders,
        })

        const _response = responseMapper(response)
        onSuccess(_response)
        return _response
    } catch (error) {
        const _error = errorMapper(error)
        if (_isFunction(onError)) {
            onError(_error)
        } else {
            throw _error
        }
    }
}

const TransferVcoins = async (
    transferDetails,
    msisdn,
    customHeaders = {},
    utilities = {},
) => {
    const _utilities = retrieveUtilities(utilities)

    const { onStart, onSuccess, onError, responseMapper, errorMapper } = _utilities

    const data = {
        id: [
            {
                value: transferDetails.id,
            },
        ],
        name: transferDetails.title,
        desc: transferDetails.description,
        type: transferDetails.type,
        status: transferDetails.status,
        category: [
            {
                value: transferDetails.category,
            },
        ],
        roles: {
            sender:
            {
                id:
                    [
                        {
                            value: msisdn,
                            schemeName: 'Sender ID',
                            schemeAgencyName: 'Vodafone',
                        },
                    ],
            },
            receiver:
            {
                id:
                    [
                        {
                            value: transferDetails.receiver,
                            schemeName: 'Reciever ID',
                            schemeAgencyName: 'Vodafone',
                        },
                    ],
            },
        },
        parts: {
            triggeredBy: {
                id: [
                    {
                        value: 'selfcare',
                    },
                ],
            },
            adjustmentSpecification: {
                characteristicsValue: [
                    {
                        characteristicName: 'receiving_actual_value',
                        value: transferDetails.receiving_actual_value,
                        type: 'receiving_monthly_limit',
                    },
                    {
                        characteristicName: 'receiving_max_value',
                        value: transferDetails.receiving_max_value,
                        type: 'receiving_monthly_limit',
                    },
                    {
                        characteristicName: 'transfering_actual_value',
                        value: transferDetails.transfering_actual_value,
                        type: 'transfering_monthly_limit',
                    },
                    {
                        characteristicName: 'transfering_max_value',
                        value: transferDetails.transfering_max_value,
                        type: 'transfering_monthly_limit',
                    },
                    {
                        characteristicName: 'number_of_transfer_value',
                        value: transferDetails.number_of_transfer_value,
                        type: 'number_of_transfer',
                    },
                    {
                        characteristicName: 'number_of_transfer_limit',
                        value: transferDetails.number_of_transfer_limit,
                        type: 'number_of_transfer',
                    },
                    {
                        characteristicName: 'transaction_fee',
                        value: transferDetails.transaction_fee,
                    },
                ],
            },
        },
        relatedParty: [
            {
                id:
                    [
                        {
                            value: msisdn,
                        },
                    ],
            },
        ],
    }

    onStart()

    try {
        const response = await axios.post(API_URLS.transferVcoins, data, {
            headers: customHeaders,
        })

        const _response = responseMapper(response)
        onSuccess(_response)
        return _response
    } catch (error) {
        const _error = errorMapper(error)
        if (_isFunction(onError)) {
            onError(_error)
        } else {
            throw _error
        }
    }
}

export {
    GetTransferBalanceOptions,
    GetTransferDataOptions,
    GetTransferVcoinsOptions,
    TransferBalance,
    TransferData,
    TransferVcoins,
}
